import client from "@/api/client";
import vuei18n from "@/plugins/i18n.js";
import {
    HubConnectionBuilder,
    //HttpTransportType,
    HubConnectionState,
    LogLevel
} from '@microsoft/signalr';
import Vue from 'vue';

export const NotificationStore = {
    namespaced: true,
    state: {
        connectionState: null,
        shutdown: null,
        eventHub: null,
        connectionId: null,
        notifications: [],
        activeroute: {},    // Locally set
        sharedroutelist: [], // remove set
    },
    mutations: {
        SET_SHAREDROUTELIST(state, payload) {

            state.sharedroutelist = payload;
        },
        SET_ACTIVEROUTE(state, payload) {
            state.activeroute = payload;
        },
        PUSH_SHAREDROUTE(state, payload) {

            const itemIndex = state.sharedroutelist.findIndex(e => e.connectionId === payload.connectionId);

            if (itemIndex >= 0) {
                if (payload.path !== state.activeroute.Path) {
                    state.sharedroutelist.splice(itemIndex, 1);
                }
            }
            else {
                if (payload.path === state.activeroute.Path) {
                    state.sharedroutelist.push(payload);
                }
            }
        },
        ADD_NOTIFICATION(state, payload) {
            state.notifications.push(payload);
        },
        REMOVE_NOTIFICATION(state, taskId) {
            const itemIndex = state.notifications.findIndex((e) => e.taskId == taskId);
            state.notifications.splice(itemIndex, 1);
        },
        UPDATE_NOTIFICATION(state, payload) {
            const itemIndex = state.notifications.findIndex((e) => e.taskId == payload.index);
            if (itemIndex >= 0) {
                for (var propertyName in payload.content) {
                    Vue.set(state.notifications[itemIndex], propertyName, payload.content[propertyName]);
                }
            }
        },
        CLEAR_NOTIFICATIONS(state) {
            state.notifications = [];
        },
        //Type
        UPDATE_CONNECTION_ID(state, payload) {
            state.connectionId = payload;
            state.connectionState = window.eventHub.connection._connectionState;
        },
        SET_CONNECTIONSTATE(state, connectionState) {
            state.connectionState = connectionState;
        },
        DISCONNECT() {
            if (window.eventHub != null) {
                window.eventHub.stop();
                window.eventHub = null;
            }
        },
        SHUTDOWN(state, args) {
            state.shutdown = args;
        }
    },
    actions: {
        restartTask({ commit }, item) {
            if (item.status == "failed") {
                commit("UPDATE_NOTIFICATION", { index: item.taskId, content: { status: "restart", displayText: "Restarting" } })
                client().post("/api2/task/restart/" + item.taskId);
            }
        },
        closeTask({ commit }, item) {
            commit("REMOVE_NOTIFICATION", item.taskId);
        },
        stopTask({ commit }, item) {
            commit("UPDATE_NOTIFICATION", { index: item.taskId, content: { status: "stop", displayText: "Stopping" } })
            client().post("/api2/task/cancel/" + item.taskId);
        },
        // a little update logic to make it look
        // better on long running tasks
        timeout({ commit, state, dispatch }, { id, count }) {
            //fallback in case items/completed don't disappear
            const itemIndex = state.notifications.findIndex((e) => e.taskId == id);
            if (itemIndex < 0) return;
            if (count < 100) {
                const item = state.notifications[itemIndex];
                if (item.status != "failed" && item.status != "completed") {
                    if (count == 5) {
                        commit("UPDATE_NOTIFICATION", { index: id, content: { displayText: item.displayText + ` taking longer than expected...` } });
                    }
                    setTimeout((index) => dispatch("timeout", index), 5000, { id: id, count: count + 1 });
                }
            } else {
                commit("REMOVE_NOTIFICATION", id);
            }
        },
        onTaskReceived({ commit, state, dispatch }, taskArg) {
            var logtext = "%c[TaskRecv]";
            var logarray = [
                `color: #7c5ac7;` // style for [TaskRecv]
            ]
            var color;
            if (taskArg.task?.planName) {
                logtext += ' %c' + taskArg.task.planName;
                color = `#FFFFFF;`;
                logarray.push('color: ' + color + ';');
            }
            if (taskArg.status) {
                logtext += ' %c' + taskArg.status;
                const expr = taskArg.status;
                switch (expr) {
                    case 'failed':
                        color = `#FF0000;`;
                        break;
                    case 'created':
                        color = `#c4a026;`;
                        break;
                    case 'update':
                        color = `#5184b5;`;
                        break;
                    case 'completed':
                        color = `#0dbc79;`;
                        break;
                    default:
                        color = `#FFFFFF;`;
                }
                logarray.push('color: ' + color + ';');

                if (taskArg.progress) {
                    logtext += ' ' + taskArg.progress + '%';
                }
            }
            if (taskArg.displayText) {
                logtext += ' %c' + taskArg.displayText;
                color = `#FFFFFF;`;
                logarray.push('color: ' + color + ';');
            }

            console.log.apply(this, [logtext, ...logarray]);
            if (taskArg.className == "TaskCreatedEventArgs" && taskArg.status == "created") {
                const itemIndex = state.notifications.findIndex((e) => e.taskId == taskArg.taskId);
                if (itemIndex < 0) {
                    commit("ADD_NOTIFICATION", { displayText: vuei18n.t("task." + taskArg.task.planName), icon: "mdi-briefcase", ...taskArg });
                    setTimeout((index) => dispatch("timeout", index), 10000, { id: taskArg.taskId, count: 1 });
                } else {
                    const content = { status: taskArg.status, displayText: "task." + taskArg.task.planName }
                    commit("UPDATE_NOTIFICATION", { index: taskArg.taskId, content: content });
                }
            }
            else if (taskArg.className == "TaskCompletedEventArgs" && taskArg.status == "completed") {
                commit("UPDATE_NOTIFICATION", { index: taskArg.taskId, content: { status: taskArg.status, task: taskArg.task } });
                if (taskArg?.task?.keepInNotificationBar !== true) {
                    setTimeout(() => {
                        commit("REMOVE_NOTIFICATION", taskArg.taskId);
                    }, 4000);
                }
            }
            else if (taskArg.className == "TaskFailedEventArgs" && taskArg.status == "failed") {
                const content = { status: taskArg.status, displayText: taskArg.errorMessage };
                commit("UPDATE_NOTIFICATION", { index: taskArg.taskId, content: content });
                setTimeout(() => {
                    commit("REMOVE_NOTIFICATION", taskArg.taskId);
                }, 25000);
            } else if (taskArg.className == "TaskUpdateEventArgs" && taskArg.status == "update") {
                const content = { displayText: taskArg.displayText, progress: taskArg.progress, status: taskArg.status };
                commit("UPDATE_NOTIFICATION", { index: taskArg.taskId, content: content });
            }
        },
        route({ state, commit }, payload) {
            commit("SET_ACTIVEROUTE", payload);
            if (window.eventHub && window.eventHub.state == HubConnectionState.Connected && state.connectionId) {
                window.eventHub.invoke("Route", payload);
            }
        },
        // create custom notification, example: 
        // $store.dispatch('NotificationStore/notify',{message: 'test',icon: 'mdi-alert', timeoutMs: 5000});
        notify({ commit }, { message, icon, timeoutMs }) {
            const id = Date.now();
            commit("ADD_NOTIFICATION", { displayText: message, icon: icon, status: "completed", taskId: id });
            setTimeout(() => {
                commit("REMOVE_NOTIFICATION", id);
            }, timeoutMs);
        },
        subscribe(args, payload) {
            if (window.eventHub) {
                window.eventHub.on(payload[0], payload[1]);
            }
            else {
                console.log("A component attempted to subscribe to event hub while not connected");
            }
        },
        unsubscribe(args, payload) {
            if (window.eventHub) {
                window.eventHub.off(payload[0], payload[1]);
            }
            else {
                console.log("A component attempted to unsubscribe to event hub while not connected");
            }
        },
        connect({ state, getters, commit, dispatch }) {
            if (window.eventHub != null) {

                // Start the eventHub.
                if (window.eventHub.state != HubConnectionState.Connected) {

                    window.eventHub.start();
                }
                return;
            }
            else {
                commit("DISCONNECT");
            }
            window.eventHub = new HubConnectionBuilder()
                .withUrl("/eventNotifications", {
                    accessTokenFactory: () => getters.accessToken,
                    //skipNegotiation: true,
                    //transport: HttpTransportType.WebSockets,
                })
                .withAutomaticReconnect({
                    nextRetryDelayInMilliseconds: context => {
                        console.log("Re-trying websocket connection...")
                        commit("SET_CONNECTIONSTATE", window.eventHub.connection._connectionState);
                        return context.elapsedMilliseconds < 120000 ? 3000 : 60000;
                    }
                })
                .configureLogging(LogLevel.Critical)
                .build();

            // We can subscribe to our connectionId
            // setup, so that we can direct XHR calls 
            // and receive commands privately back
            window.eventHub.on("connectionid", (args) => {
                // first signal,lets check if restart is set.
                if (state.shutdown) {
                    commit("SHUTDOWN", null);
                    window.location.reload();
                }
                commit("UPDATE_CONNECTION_ID", args);
            });

            window.eventHub.on("shutdown", (args) => {
                commit("SHUTDOWN", args);
            });

            window.eventHub.on("config", (args) => {
                dispatch("Job/updateconfig", args, { root: true });
            });

            window.eventHub.on("tasks", (args) => {
                dispatch("onTaskReceived", args);
            });

            window.eventHub.on("error", (args) => {
                dispatch("ErrorStore/add", args, { root: true });
            });

            // used to keep track of concurrent views
            window.eventHub.on("sharedroute", (args) => {
                commit("PUSH_SHAREDROUTE", args);
            });

            window.eventHub.on("sharedroutelist", (args) => {
                commit("SET_SHAREDROUTELIST", args);
            });

            window.eventHub.onreconnected((id) => {
                commit("UPDATE_CONNECTION_ID", id);
                commit("SET_CONNECTIONSTATE", window.eventHub.connection._connectionState);
                if (state.shutdown) {
                    commit("SHUTDOWN", null);
                    window.location.reload();
                }
                commit("CLEAR_NOTIFICATIONS");
            });

            // Start the eventHub.
            // if it fails the first time, its probably because
            // of expired access token, in which case,
            // will cause the connect method to be called again


            function startHub() {
                if (getters.accessToken) {
                    window.eventHub.start().then(() => {
                        commit("SET_CONNECTIONSTATE", window.eventHub.connection._connectionState);
                        if (state.activeroute.Path) {
                            window.eventHub.invoke("Route", state.activeroute);
                        }
                    }).catch(error => {
                        console.log("Websocket failed to start: ", error);
                        window.eventHub.stop();
                        setTimeout(function () {
                            console.log("Retrying websocket connection")
                            startHub();
                        }, 3000);
                    });
                }
            }
            startHub();
        }
    },
    getters: {
        accessToken: (_a, _b, rootState) => {
            return rootState.token?.access_token;
        },
        connectionState: () => {
            if (window.eventHub) {
                console.log("CONNECTIONSTATE", window.eventHub.connection._connectionState)
                return window.eventHub.connection._connectionState;
            }
            return 'inactive';
        }
    },
}